import React from 'react';

import api from '../../api';

import SweetAlert from 'sweetalert2-react';

import ResidenceStatus from './ResidenceStatus';
import ResidentType from './ResidentType';
import MarriedStatus from './MarriedStatus';
import DependentChildren from './DependentChildren';
import Month from './Month';
import Remuneration from './Remuneration';
import EPF from './EPF';
import SOCSO from './SOCSO';
import EIS from './EIS';
import PreviousPayslips from './PreviousPayslips';
import GroupTitle from './GroupTitle';
import Result from './Result';
import ActionBar from './ActionBar';
import Contribution from './Contributions';
import PersonalInfoForm from './PersonalInfoForm';

export default class Calculator extends React.Component {
    constructor() {
        super();

        this.state = this.getInitialState();
    }

    getInitialState = () => ({
        employee: {
            nationality: 'MY',
            isResident: true,
            isDisabled: false,
            residentSubType: 0,
            marriedStatus: 1,
            children: [],
            isEpf: true,
            epfRate: 0.07,
            socsoCategory: 1,
            isEis: true
        },
        month: 1,
        payrollDetails: {
            total: 0,
            reccuring: 0,
            oneOff: 0,
            epf: 0,
            socso: 0,
            eis: 0
        },
        previousPayslips: {
            hidden: false,
            gross: 0,
            epf: 0,
            socso: 0,
            pcb: 0
        },
        result: {
            salary: 0,
            bonus: 0,
            socso: 0,
            eis: 0,
            epf: 0,
            mtd: 0,
            total: 0,
            deductions: 0,
            net: 0
        },
        updated: false,
        resultKey: 0,
        isPreparingPayslip: false,
        isPayslipSent:
            localStorage.getItem('isPayslipSent') === 'true' || false,
        showPayslipNotification: false,
        errors: {
            total: 'Provide total value!'
        },
        notification: {
            show: false
        },
        isShowDialog: false
    })

    handleEmployeeUpdate = (property, value) => {
        const isChanged = this.state.employee[property] !== value ||
            property === 'children';

        if (isChanged) {
            const newEmployee = Object.assign({},
                this.state.employee,
                {
                    [property]: value
                }
            );

            const newState = Object.assign({},
                this.state, {
                    employee: newEmployee
                }
            );

            this.onUpdate(newState);
        }
    }

    handlePayrollDetails = (newPayrollDetails) => {
        const hasTotalChanged =
            newPayrollDetails.total !== this.state.payrollDetails.total;
        const hasRecurringTotalChanged =
            newPayrollDetails.recurring !==
                this.state.payrollDetails.recurring;
        const hasOneOffChanged =
            newPayrollDetails.oneOff !== this.state.payrollDetails.oneOff;

        const hasChanged = hasTotalChanged ||
            hasRecurringTotalChanged || hasOneOffChanged;

        if (hasChanged) {
            const newState = Object.assign({},
                this.state,
                {
                    payrollDetails: newPayrollDetails
                }
            );

            this.onUpdate(newState);
        }
    }

    handleTaxes = (isRaw, property, value) => {
        let newEmployee = null;
        let newPayrollDetails = null;
        const newValue = value || 0;

        switch(property) {
            case 'epf':
                newEmployee = Object.assign({},
                    this.state.employee,
                    {
                        isEpf: !isRaw,
                        epfRate: !isRaw ? parseFloat(newValue) : ''
                    }
                );

                newPayrollDetails = Object.assign({},
                    this.state.payrollDetails,
                    {
                        epf: isRaw ? parseFloat(newValue) : 0
                    }
                );

                break;
            case 'socso':
                newEmployee = Object.assign({},
                    this.state.employee,
                    {
                        socsoCategory: isRaw ? 0 : newValue,
                    }
                );

                newPayrollDetails = Object.assign({},
                    this.state.payrollDetails,
                    {
                        socso: isRaw ? parseFloat(newValue) : 0
                    }
                );

                break;
            case 'eis':
                newEmployee = Object.assign({},
                    this.state.employee,
                    {
                        isEis: !isRaw && newValue
                    }
                );

                newPayrollDetails = Object.assign({},
                    this.state.payrollDetails,
                    {
                        eis: isRaw ? parseFloat(newValue) : 0
                    }
                );

                break;
            default:
                console.log('Something bad happened!');
        }

        const newState = Object.assign({},
            this.state,
            {
                employee: newEmployee,
                payrollDetails: newPayrollDetails
            }
        );

        this.onUpdate(newState);
    }

    handlePreviousPayslips = (newPreviousPayslips) => {
        const hasGrossChanged =
            newPreviousPayslips.gross !== this.state.previousPayslips.gross;
        const hasEPFChanged =
            newPreviousPayslips.epf !== this.state.previousPayslips.epf;
        const hasSOCSOChanged =
            newPreviousPayslips.socso !== this.state.previousPayslips.socso;
        const hasPCBChanged =
            newPreviousPayslips.pcb !== this.state.previousPayslips.pcb;

        const hasChanged = hasGrossChanged || hasEPFChanged ||
            hasSOCSOChanged || hasPCBChanged;

        if (hasChanged) {
            const newState = Object.assign({},
                this.state,
                {
                    previousPayslips: newPreviousPayslips
                }
            );

            this.onUpdate(newState);
        }
    }

    handleMonth = (newMonth) => {
        const newState = Object.assign({},
            this.state,
            {
                month: newMonth
            }
        );

        this.onUpdate(newState);
    }

    validateFields = (state) => {
        return {
            total:
                !state.payrollDetails.total ||
                state.payrollDetails.total === '0.00' ?
                    'Please provide gross salary!' : ''
        };
    }

    onUpdate = (newState) => {
        let self = this;

        newState.errors = this.validateFields(newState);

        // check if there is an error on total
        if (newState.errors.total) {
            this.setState(Object.assign(newState, {
                result: this.getInitialState().result
            }));

            return;
        }

        // run calculator on every blur event
        api.calculate(newState)
            .then(response => {
                self.setState(Object.assign({},
                    newState, {
                        result: response.data.result,
                        updated: true,
                        resultKey: newState.resultKey === 1 ? 0 : 1
                    }
                ));
            })
            .catch(error => {
                console.log(error);

                self.setState(newState);
            });
    }

    getPayslip = (personalInfo) => {
        if (!personalInfo.email) {
            return;
        }

        this.setState(Object.assign({}, this.state, {
            isPreparingPayslip: true
        }));

        api.sendPayslip(Object.assign(
            {},
            this.state,
            personalInfo
        ))
            .then(response => {
                // store to local storage
                localStorage.setItem('isPayslipSent', true);

                setTimeout(() => {
                    this.setState(Object.assign({}, this.state, {
                        isPreparingPayslip: false,
                        isPayslipSent: true,
                        isShowDialog: false,
                        notification: {
                            show: true,
                            type: 'success',
                            title: 'Success! Your payslip was sent to the email provided!',
                            text: response.result,
                            confirmButtonClass: 'green-background'
                        }
                    }));
                }, 2000);
            })
            .catch(error => {
                setTimeout(() => {
                    this.setState(Object.assign({}, this.state, {
                        isPreparingPayslip: false,
                        isShowDialog: false,
                        notification: {
                            show: true,
                            type: 'error',
                            title: 'Error!',
                            text: error,
                            confirmButtonClass: 'red-background'
                        }
                    }));
                }, 2000);
            });
    }

    resetForm = () => {
        localStorage.setItem('isPayslipSent', false);

        this.setState(Object.assign({},
            this.getInitialState(),
            {
                key: this.state.key === '0' ?
                    '1' : '0',
                notification: {
                    show: true,
                    type: 'success',
                    title: 'Success!',
                    text: 'Form is cleared',
                    confirmButtonClass: 'green-background'
                }
            }
        ));
    }

    handleToggleDialog = value => () => {
        this.setState(Object.assign(
            {},
            this.state,
            {
                isShowDialog: !!value
            }
        ))
    }

    render() {
        const {
            key, result, updated, resultKey, errors,
            isPreparingPayslip, isPayslipSent, notification,
            employee: { isResident },
            isShowDialog
        } = this.state;

        return (
            <div className='calculator' key={key}>
                <div className='background'>
                    <div className='image container'>

                    </div>
                </div>

                <div className='banner container'>
                    <div className='title' style={{'margin-bottom': '0px'}}>
                        Payslip Generator
                    </div>
                    <div className='title' style={{'font-size': '24px'}}>
                        Slip Gaji Generator
                    </div>

                    <div className='description'>
                        Create your staff payslip with our FREE payslip
                        generator which calculates your monthly tax 
                        deductions for you. All calculations are in 
                        accordance with LHDN.
                    </div>
                </div>

                <div className='form container' id="form-container">
                    <GroupTitle title={'Personal Details'} />
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 col-xl-4'>
                            <ResidenceStatus handleChange={value =>
                                this.handleEmployeeUpdate(
                                    'isResident',
                                    value
                                )}
                            />
                        </div>

                        {isResident &&
                            [
                                <div
                                    key='0'
                                    className='col-sm-12 col-md-6 col-xl-4'
                                >
                                    <ResidentType
                                        isVisible={isResident}
                                        handleChange={value =>
                                            this.handleEmployeeUpdate(
                                                'residentSubType',
                                                value
                                            )
                                        }
                                    />
                                </div>,
                                <div
                                    key='1'
                                    className='col-sm-12 col-md-6 col-xl-4'
                                >
                                    <MarriedStatus
                                        isVisible={isResident}
                                        handleChange={value =>
                                            this.handleEmployeeUpdate(
                                                'marriedStatus', value
                                            )
                                        }
                                    />
                                </div>
                            ]
                        }
                    </div>

                    {isResident &&
                        [
                            <GroupTitle key='2' title={'Children'} />,
                            <DependentChildren
                                key='3'
                                isVisible={isResident}
                                handleChange={value =>
                                    this.handleEmployeeUpdate(
                                        'children', value)
                                }
                            />
                        ]
                    }

                    <GroupTitle title={'Payroll & Deductions'} />
                    <Month handleChange={this.handleMonth} />

                    <Remuneration
                        handleChange={this.handlePayrollDetails}
                        errors={errors}
                    />

                    <EPF handleChange={this.handleTaxes} />

                    <SOCSO handleChange={this.handleTaxes} />

                    <EIS handleChange={this.handleTaxes} />

                    <Result mtd={result.mtd} net={result.net}
                        updated={updated} key={resultKey} />

                    <GroupTitle title={'Employee Contributions'} />
                    <Contribution eis={result.eis}
                        socso={result.socso}
                        epf={result.epf} />

                    <GroupTitle title={'Employer Contributions'} />
                    <Contribution eis={result.employerEis}
                        socso={result.employerSocso}
                        epf={result.employerEpf} />


                    <PreviousPayslips
                        handleChange={this.handlePreviousPayslips} />

                    <div className='spacing'></div>

                    <ActionBar
                        disabled={
                            isPreparingPayslip ||
                            !result.net
                        }
                        isPreparingPayslip={isPreparingPayslip}
                        isPayslipSent={isPayslipSent}
                        onResetForm={this.resetForm}
                        onOpenDialog={this.handleToggleDialog(true)}
                    />

                    <PersonalInfoForm
                        isShowDialog={isShowDialog}
                        onCloseDialog={this.handleToggleDialog(false)}
                        onSendPayslip={this.getPayslip}
                    />
                </div>

                <SweetAlert
                    show={notification.show}
                    type={notification.type}
                    title={notification.title || ''}
                    text={notification.text}
                    confirmButtonClass={notification.confirmButtonClass}
                    onConfirm={() => this.setState(
                        Object.assign(
                            {}, this.state, {
                                notification: {
                                    show: false
                                }
                            }
                        ))
                    }
                />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Calculator/index.js